import {BaseModel} from '@/models/base.model.js'
import {Channel} from '@/models/channel.model.js'
import {enrollmentStatuses} from '@/constants/enrollments.js'
import {addressTypes} from '@/constants/address-types.js'

/**
 * Enrollment model
 */
export class Enrollment extends BaseModel {

  //Sub models
  static subModels = {
    channel: Channel,
  }

  /**
   * Display name
   */
  get displayName() {
    return (this.course?.name || this.name || '').replace(' [Course Generator]', '')
  }

  /**
   * Icon
   */
  get icon() {
    return 'menu_book'
  }

  /**
   * Is paused
   */
  get isPaused() {
    return this.status === enrollmentStatuses.PAUSED
  }

  /**
   * Can pause or resume
   */
  get canPauseResume() {
    return [
      enrollmentStatuses.ACTIVE,
      enrollmentStatuses.PAUSED,
      enrollmentStatuses.NOT_ENGAGED,
    ].includes(this.status)
  }

  /**
   * Check if user can respond to the enrollment
   */
  get canRespond() {
    return [
      enrollmentStatuses.ACTIVE,
      enrollmentStatuses.PAUSED,
      enrollmentStatuses.NOT_ENGAGED,
    ].includes(this.status)
  }

  /**
   * Check if this is a Teams enrollment
   */
  get isTeams() {
    return (this.address?.addressType === addressTypes.TEAMS)
  }

  /**
   * Check if enrollment has a channel
   */
  get hasChannel() {
    return !!this.channel
  }
}
